import script from "./SetupView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetupView.vue?vue&type=script&setup=true&lang=ts"

import "./SetupView.vue?vue&type=style&index=0&id=3e5f0700&lang=scss"

const __exports__ = script;

export default __exports__